import {
    ICloseForm
} from '../actions/close-credit-card-form';
import { IBillingState } from '../state';

export const closeCreditForm =
    (state: IBillingState, action: ICloseForm) => {
        return {
            ...state,
            closeCreditForm: action.data
        }
    }
